module.exports = __webpack_public_path__ + "img/buetti-echo.3523162e.jpg";